<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer006">
<p class="TOCtitle">Table of Contents</p>
<p class="TOCitem"><a href="#/Smooth_Talking_Cowboy#_idTextAnchor001">Smooth-Talking Cowboy</a></p>
<p class="TOCitem"><span href="#/Seduce_Me_Cowboy#_idTextAnchor026" title="Link target outside of Sample">Seduce Me, Cowboy</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Table_of_Contents.vue?30b51a5f